import { format } from "date-fns";
import { useLocale } from "next-intl";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { getCouponsHistoryPaginated } from "@/api/coupons";
import { ExtractNextPageParam } from "@/tanstackQuery";
import { CouponsQueryKeys } from "./couponsQueryKeys";
import { DateFormat } from "@/utils/date";

import { DateRange } from "@/types/Date";

interface Filters {
  status?: string;
  state?: string;
  dateRange?: DateRange;
  page?: number;
  pageSize?: number;
}

const PAGE_SIZE = 20;

const formatDate = (date: Date | undefined) => {
  if (date) {
    return format(date, DateFormat.ISO);
  }
};

const getFiltersParams = (filters: Filters) => {
  return {
    page: filters.page || 1,
    pageSize: filters.pageSize || PAGE_SIZE,
    state: filters.state,
    status: filters.status === "all" ? undefined : filters.status,
    startDate: formatDate(filters.dateRange?.from),
    endDate: formatDate(filters.dateRange?.to),
  };
};

const buildPaginatedParams = (page: number, filterParams: any) => {
  return { ...filterParams, page, pageSize: PAGE_SIZE };
};

export const useUserCouponsHistory = (filters: Filters) => {

  const filterParams = getFiltersParams(filters);
  const locale = useLocale();

  return useQuery({
    queryKey: [CouponsQueryKeys.UserHistory, filterParams],
    queryFn: ({ signal }) => {
      const params = {
        ...filterParams,
        lang: locale
      };
      return getCouponsHistoryPaginated({ signal, params });
    },
  });
};

export const useUserCouponsHistoryInfinite = (filters: Filters) => {
  const filterParams = getFiltersParams(filters);
  const locale = useLocale();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: [CouponsQueryKeys.UserHistoryInfinite, filterParams],
    getNextPageParam: ExtractNextPageParam.fromPaginatedResponse,
    queryFn: ({ pageParam, signal }) => {
      console.log(pageParam);
      const params = {
        ...buildPaginatedParams(pageParam, filterParams),
        lang: locale,
      };
      return getCouponsHistoryPaginated({ signal, params });
    },
  });
};
